import { render, staticRenderFns } from "./TagFacultyArea.vue?vue&type=template&id=40a8e7ad&scoped=true"
import script from "./TagFacultyArea.vue?vue&type=script&lang=js"
export * from "./TagFacultyArea.vue?vue&type=script&lang=js"
import style0 from "./TagFacultyArea.vue?vue&type=style&index=0&id=40a8e7ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a8e7ad",
  null
  
)

export default component.exports